import { render } from "./Project.vue?vue&type=template&id=932f8930&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-932f8930"

export default script